import { render, staticRenderFns } from "./IntroVideosWrapper.vue?vue&type=template&id=38629278"
import script from "./IntroVideosWrapper.vue?vue&type=script&lang=js"
export * from "./IntroVideosWrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports